export type TrialWindow = {
  isTrial: boolean;
  isTrialEnded: boolean;
  trialDaysRemaining: number;
  trialStartDate: Date | null;
  trialEndDate: Date | null;
};

export function isActiveTrialSubscription(
  subscription:
    | {
        status?: string | null;
        is_trial?: boolean | null;
        trial_expired?: boolean | null;
      }
    | null
    | undefined
): boolean {
  if (!subscription) return false;
  if (subscription.trial_expired) return false;
  if (subscription.status === "trialing") return true;
  return Boolean(subscription.is_trial);
}

const FIRST_RUN_WINDOW_HOURS = 48;

export function isWithinFirstRunWindow(
  createdAtInput: string | Date | null | undefined
): boolean {
  if (createdAtInput == null) return false;
  if (typeof createdAtInput === "string" && createdAtInput.trim() === "") {
    return true;
  }

  const createdAt =
    createdAtInput instanceof Date ? createdAtInput : new Date(createdAtInput);

  if (Number.isNaN(createdAt.getTime())) return false;

  const hoursSinceCreation =
    (Date.now() - createdAt.getTime()) / (1000 * 60 * 60);

  return hoursSinceCreation >= 0 && hoursSinceCreation < FIRST_RUN_WINDOW_HOURS;
}

export function computeSevenDayTrialWindow(
  createdAtInput: string | Date | null | undefined
): TrialWindow {
  if (!createdAtInput) {
    return {
      isTrial: false,
      isTrialEnded: false,
      trialDaysRemaining: 0,
      trialStartDate: null,
      trialEndDate: null,
    };
  }

  const createdAt =
    createdAtInput instanceof Date ? createdAtInput : new Date(createdAtInput);

  if (Number.isNaN(createdAt.getTime())) {
    return {
      isTrial: false,
      isTrialEnded: false,
      trialDaysRemaining: 0,
      trialStartDate: null,
      trialEndDate: null,
    };
  }

  const trialDurationDays = 7;
  const trialStartDate = createdAt;
  const trialEndDate = new Date(
    createdAt.getTime() + trialDurationDays * 24 * 60 * 60 * 1000
  );
  const now = new Date();

  const isTrial = now < trialEndDate;
  const diffMs = trialEndDate.getTime() - now.getTime();
  const trialDaysRemaining = isTrial
    ? Math.max(0, Math.ceil(diffMs / (24 * 60 * 60 * 1000)))
    : 0;

  return {
    isTrial,
    isTrialEnded: !isTrial,
    trialDaysRemaining,
    trialStartDate,
    trialEndDate,
  };
}
